













































































































































































































import { Component, Prop, Vue, Emit,Watch } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class DirectAccessDialog extends Vue {
  @Prop({default:null}) public source:Common.DirectAccessTargetFlags; 
  @Prop({default:null}) public sourceNo:string;
  @Prop({default:false}) public isItem:boolean;

  showDialog: boolean = false;
  queryResult : Common.DirectAccessQueryResult;
  DirectAccessTargetFlags = Common.DirectAccessTargetFlags;

  created(){
    this.$api.execute(new Common.DirectAccessQuery(this.source,this.sourceNo,this.isItem))
    .then(obj => {
        this.queryResult = obj;
        this.showDialog = true;
      })
  }
  
  isVisible(target : Common.DirectAccessTargetFlags){
    return (this.queryResult.target & target) > 0;
  }

  get hasLicenseImport() :boolean{
    return this.$api.hasLicense(Common.licenseFlags.import);
  }
  get hasLicenseExport() :boolean{
    return this.$api.hasLicense(Common.licenseFlags.export);
  }


  onOk(){
    this.showDialog = false;
  }

  onAllocationClick(){
      this.onLinkClick('/sales/SalesDeliveryItem?orderItemNo=' + this.sourceNo + '&state=' + Common.StockBalanceJournalStatus.SalesDeliveryInstructionWaiting);
  }
  onInvoiceClick(invoiceNo:string,state :number){
    if ((state & Common.InvoiceStatus.CarryOver) == 0) this.onLinkClick('/sales/AloneInvoice?invoiceNo=' + invoiceNo);
    else this.onLinkClick('/sales/CarryOverInvoice?invoiceNo=' + invoiceNo);
  }

  onLinkClick(path : string){
    this.showDialog = false;
    this.$router.push(path);
    // let routeData = this.$router.resolve(path);
    // window.open(routeData.href, '_blank');        
  }

}
